import { render, staticRenderFns } from "./Law.vue?vue&type=template&id=5885262c&scoped=true"
import script from "./Law.vue?vue&type=script&lang=ts"
export * from "./Law.vue?vue&type=script&lang=ts"
import style0 from "./Law.vue?vue&type=style&index=0&id=5885262c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885262c",
  null
  
)

export default component.exports